import { render, staticRenderFns } from "./DnsOptions.vue?vue&type=template&id=baa9115e&scoped=true"
import script from "./DnsOptions.vue?vue&type=script&lang=js"
export * from "./DnsOptions.vue?vue&type=script&lang=js"
import style0 from "./DnsOptions.vue?vue&type=style&index=0&id=baa9115e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa9115e",
  null
  
)

export default component.exports